import { createSlice } from '@reduxjs/toolkit';
import { FilterMatchMode } from 'primereact/api';

import {
  countOfIncomingSmsTableFilters,
  CountofOutgoingSmsSlice,
  countOfOutgoingSmsSliceFilter,
} from '../../components/Admin/TennantBilling/interface/tenantBilling.interface';

const INITIAL_FILTERS: countOfIncomingSmsTableFilters = {
  client_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  year: { value: null, matchMode: FilterMatchMode.CONTAINS },
  month: { value: null, matchMode: FilterMatchMode.CONTAINS },
  group_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

const outgoingSmsFiltersSlice = createSlice({
  name: 'outgoingSmsFilters',
  initialState: INITIAL_FILTERS,
  reducers: {
    updateOutgoingSmsFilter(state, { payload }: CountofOutgoingSmsSlice) {
      const { field, value, matchMode } = payload;
      state[field] = { value, matchMode };
    },
    setAllFilters(_, { payload }: countOfOutgoingSmsSliceFilter) {
      return payload;
    },
    clearFilters() {
      return INITIAL_FILTERS;
    },
  },
});

export const { updateOutgoingSmsFilter, setAllFilters, clearFilters } =
  outgoingSmsFiltersSlice.actions;

export const outgoingSmsFiltersReducer = outgoingSmsFiltersSlice.reducer;
